import React from 'react';
import { s as styleInject } from '../../style-inject.es-e7b07dd7.js';

var css_248z = ".AY4QY,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.AONEd{width:100%}[dir] .AONEd{margin:8px auto 0}.AONEd .XKM9i{height:1px}[dir] .AONEd .XKM9i{background-color:var(--ricos-settings-dividers-color,rgba(51,51,51,.2))}@supports not (contain:inline-size){@media only screen and (max-width:640px){.AONEd .XKM9i{width:100%}[dir] .AONEd .XKM9i{margin:0}}}@container (width < 640px){.AONEd .XKM9i{width:100%}[dir] .AONEd .XKM9i{margin:0}}";
var styles = {"fontElementMap":"AY4QY","whitespace":"AONEd","divider":"XKM9i"};
styleInject(css_248z);

const ListItemSection = ({ type }) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.whitespace }, type === "divider" && /* @__PURE__ */ React.createElement("div", { className: styles.divider }));
};

export { ListItemSection as default };
//# sourceMappingURL=ListItemSection.js.map
